export const shouldShowGreenBg = (item: any) => {
  if (!item?.membership) return true
  else if (item?.membership && item?.isNew) return true
  else return false
}
